var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 7,
    viewBox: "0 0 8 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.03763 0.538462C3.46535 -0.179486 4.53465 -0.179488 4.96237 0.538461L7.84946 5.38461C8.27718 6.10256 7.74254 7 6.8871 7H1.1129C0.257467 7 -0.277182 6.10256 0.150536 5.38462L3.03763 0.538462Z",
    fill: "#C4CDD5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortArrowUp);
export default __webpack_public_path__ + "static/media/sort-arrow-up.437891e26f2cd129598dfa288ba74829.svg";
export { ForwardRef as ReactComponent };